export default __webpack_public_path__ + "static/media/8_1_logo.d5bdd160.png";